package com.vizio.redwolf.pay.model

data class OfferDetailsByOfferIdRequestInfo(
    val offerId: String,
    val pin: String,
    val accessToken: String
)